import React from 'react';
import PageMeta from '../components/PageMeta';

const sections = [
  {
    title: '1. General Information',
    body: [
      'The BTree Company provides research, intelligence reports, educational material and related information for general informational and educational purposes only.',
      'The content published on the platform reflects views and analysis based on information available at the time of publication and may change without notice.',
    ],
  },
  {
    title: '2. Not Financial Advice',
    body: [
      'Nothing on this platform constitutes financial, investment, trading, portfolio-management, accounting, tax or other professional advice.',
      'BTree does not recommend that any person buy, sell, hold or otherwise transact in any security, asset or financial product based on platform content.',
    ],
  },
  {
    title: '3. Independent Decision-Making',
    body: [
      'Users are responsible for conducting their own research and obtaining advice from appropriately qualified professionals before making financial or other decisions.',
      'Past performance, projections, estimates, scenarios and examples are not guarantees of future results. Actual outcomes may differ materially from any information presented.',
    ],
  },
  {
    title: '4. Market and Investment Risk',
    body: [
      'Investing and trading involve risk, including possible loss of some or all invested capital. Market prices can be volatile and affected by economic, political, regulatory and other events.',
      'BTree does not guarantee the accuracy, completeness, timeliness or suitability of any market data, company information, valuation, forecast or opinion appearing on the platform.',
    ],
  },
  {
    title: '5. Legal, Tax and Professional Content',
    body: [
      'Legal, tax, accounting, governance, policy and educational content is provided for general reference and does not establish a professional-client relationship or replace advice from a qualified practitioner.',
      'Laws, regulations, policies and interpretations can change. Users should verify current requirements and seek professional guidance for their circumstances.',
    ],
  },
  {
    title: '6. Third-Party Information and Links',
    body: [
      'Reports may refer to third-party sources, companies, websites or services. BTree is not responsible for the availability, accuracy or content of third-party materials.',
      'Links to external websites are provided for convenience and do not imply endorsement or affiliation unless expressly stated.',
    ],
  },
  {
    title: '7. No Warranty',
    body: [
      'The platform and its content are provided on an “as available” basis without warranties of any kind, express or implied, to the maximum extent permitted by applicable law.',
      'BTree does not warrant uninterrupted access, error-free operation or that the content will meet a user’s particular requirements.',
    ],
  },
  {
    title: '8. Contact',
    body: [
      'Questions about this Disclaimer may be sent to contact@thebtree.com.',
    ],
  },
];

const Disclaimer = () => (
  <>
    <PageMeta
      title="Disclaimer | The B Tree"
      description="Read the B Tree disclaimer covering market analysis, research limitations, legal and professional guidance, and platform limitations."
      canonical="https://www.thebtree.com/disclaimer"
      image="https://www.thebtree.com/logo.png"
      type="website"
    />
    <main className="min-h-screen bg-[#F7F5F2]" data-testid="disclaimer-page">
    <section className="bg-gradient-to-b from-[#FDFCFB] to-[#F7F5F2] border-b border-[#C8A84B]/20">
      <div className="max-w-5xl mx-auto px-6 md:px-12 lg:px-16 py-14 md:py-18">
        <p className="text-[11px] font-mono tracking-[0.3em] uppercase text-[#C8A84B] font-semibold mb-3">
          BTree Policies
        </p>
        <h1 className="text-4xl md:text-6xl font-[Cormorant_Garamond] font-medium text-[#0D1B2A] leading-[1.05] mb-4">
          Disclaimer
        </h1>
        <p className="text-sm md:text-base text-slate-600">
          Effective Date: June 15, 2026
        </p>
      </div>
    </section>

    <section className="max-w-5xl mx-auto px-6 md:px-12 lg:px-16 py-12 md:py-16">
      <article className="bg-white border border-slate-200 rounded-2xl p-6 md:p-10 shadow-sm">
        <p className="text-lg leading-8 text-slate-700 mb-12">
          Please read this Disclaimer carefully before relying on any information published by The BTree Company.
        </p>
        <div className="space-y-10">
          {sections.map((section) => (
            <section key={section.title}>
              <h2 className="text-2xl md:text-3xl font-[Cormorant_Garamond] font-medium text-[#0D1B2A] mb-3">
                {section.title}
              </h2>
              {section.body.map((paragraph) => (
                <p key={paragraph} className="text-slate-700 leading-7 mb-4">
                  {paragraph.includes('contact@thebtree.com') ? (
                    <>
                      Questions about this Disclaimer may be sent to{' '}
                      <a href="mailto:contact@thebtree.com" className="font-medium text-[#9B7A21] hover:text-[#0D1B2A] underline underline-offset-4">
                        contact@thebtree.com
                      </a>
                      .
                    </>
                  ) : paragraph}
                </p>
              ))}
            </section>
          ))}
        </div>
      </article>
    </section>
  </main>
  </>
);

export default Disclaimer;
